import GetCustomerRequestModelBase from '../_generated/modelBases/get-customer-request-model-base';

export default class GetCustomerRequestModel extends GetCustomerRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
